import { useTheme } from "@emotion/react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Autocomplete,
  Avatar,
  Box,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Header({ brands }) {
  brands = [
    {
      BrandId: 8438,
      BrandName: "iCreate Demo",
    },
    {
      BrandId: 11609,
      BrandName: "itay test",
    },
    {
      BrandId: 8816,
      BrandName: "_test",
    },
    {
      BrandId: 10359,
      BrandName: "iCreate One",
    },
  ];
  const navigate = useNavigate();
  const theme = useTheme();
  const primaryColor = theme.palette.background.default;
  const { brandId } = useParams();

  const handleBrandChange = (event, newValue) => {
    if (newValue) {
      navigate(`/journeys/${newValue.BrandId}`);
    } else {
      navigate("/journeys");
    }
  };

  const currentBrand = useMemo(() => {
    console.log(brands);

    if (!brands || !brandId) return null;
    return (
      brands.find((brand) => String(brand.BrandId) === String(brandId)) || null
    );
  }, [brands, brandId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        marginTop: 2,
        width: "98vw",
      }}
    >
      <MenuIcon sx={{ padding: "2vh", fontSize: "1.5vw" }} />
      <Autocomplete
        options={brands || []}
        sx={{ width: "9vw" }}
        value={currentBrand}
        onChange={handleBrandChange}
        getOptionLabel={(option) => option?.BrandName || ""}
        isOptionEqualToValue={(option, value) =>
          option?.BrandId === value?.BrandId
        }
        getOptionDisabled={(option) => option?.BrandId === brandId}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Brand"
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: primaryColor,
              },
            }}
          />
        )}
      />
      <Tooltip title="My Profile">
        <IconButton sx={{ marginLeft: "auto", alignItems: "center" }}>
          <Avatar sx={{ width: 32, height: 32 }}>M</Avatar>
        </IconButton>
      </Tooltip>
    </Box>
  );
}
